import type { QueryClient } from "@tanstack/react-query";
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { AmbientBackground } from "~/components/shell/brand";
import { TooltipProvider } from "~/components/ui/menu";
import { Toaster } from "~/components/ui/toaster";
import { ThemeProvider } from "~/lib/theme";

export interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  component: RootLayout,
});

function RootLayout() {
  return (
    <ThemeProvider>
      <TooltipProvider>
        <AmbientBackground />
        <Outlet />
        <Toaster />
      </TooltipProvider>
    </ThemeProvider>
  );
}
